/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
//TODO:  Need to fix context implementations.  Maybe via a custom context hook
//TODO:  Need to fix reloadAccounts mechanism.  Not very good and being abused by doing multiple responsibilities, triggering reloads in user, system etc
import type { ReactNode } from 'react';
import React from 'react';

export type SideMenuContextProps = {
  /** True whenever the nav is showing its labels — pinned-open, or hover-expanded while unpinned. */
  drawerOpen: boolean;
  setDrawerOpen: (val: boolean) => void;
  drawerToggle: () => void;
  /** Pinned nav reserves layout width; unpinned nav auto-hides to the rail and overlays on hover. */
  isPinned: boolean;
  togglePinned: () => void;
  /** Whether hovering the rail reveals an unpinned nav.  Off, only the toggle opens it. */
  isAutoHideEnabled: boolean;
  toggleAutoHide: () => void;
  /** Hover intent from the nav itself; ignored while pinned. */
  setHoverExpanded: (val: boolean) => void;
  setContent: (content: ReactNode) => void;
  content: ReactNode;
  reloadAccounts: Date | null;
  setReloadAccounts: (val: Date | null) => void;
  isMobileOrTablet: boolean;
};

const initialValue = {
  drawerOpen: true,
  setDrawerOpen: (val: boolean) => {},
  drawerToggle: () => {},
  isPinned: false,
  togglePinned: () => {},
  isAutoHideEnabled: true,
  toggleAutoHide: () => {},
  setHoverExpanded: (val: boolean) => {},
  setContent: (content: ReactNode) => {},
  content: {},
  reloadAccounts: null,
  setReloadAccounts: (val: Date | null) => {},
  isMobileOrTablet: false
} as SideMenuContextProps;

const SideMenuContext = React.createContext<SideMenuContextProps>(initialValue);

export default SideMenuContext;
